import memoize from 'memoizee'
import { createSelector } from 'reselect'
import { isEmpty } from '../utils/common'
import { APPROVAL_REQUEST_FILTERS } from '../constants/FilterConstants'

const selectFilters = state => state.filters
const selectARType = state => state.approvalRequests.arType

export const selectCurrentFilter = createSelector(
  [selectARType, selectFilters],
  (arType, filters) => {
    let output = {
      filter: APPROVAL_REQUEST_FILTERS.open.value,
      groupByAICode: false,
    }

    if (!isEmpty(arType)) {
      output = filters[arType]
    }

    return output
  }
)

export const isFiltersEmpty = memoize(filters => {
  const keys = filters ? Object.keys(filters) : []
  return !keys.length || !keys.map(k => filters[k].length).filter(f => f).length
})

export const filterData = memoize((data, filters) => {
  const noFilters = isFiltersEmpty(filters)
  const filterTypes = Object.keys(filters)

  if (noFilters) {
    return data
  }

  Object.keys(filterTypes).forEach(key => {
    const f = filterTypes[key]
    const filtersArr = filters[f]
    const fn = filterFunctions[f]

    data = filtersArr.length ? data.map(item => fn(item, filtersArr)).filter(c => c) : data
  })

  return data
})
